import { Link } from "react-router";
import { shortReference, type ShortReferenceKind } from "../../shared/references/shortReferences";
import { classNames } from "../styles/classNames";
import CopyReference from "./CopyReference";

interface ReferenceDisplayProps {
  /** How the reference is shortened for reading (see shared/references/shortReferences.ts). */
  kind: ShortReferenceKind;
  /** The exact reference: shown in the tooltip, linked and copied whole. */
  value: string;
  /** Text before the short form, such as `@` for a version. */
  prefix?: string;
  /** Opens the referenced thing. */
  href?: string;
  /** The copy button's accessible name; `false` leaves the copy button out. */
  copy?: string | boolean;
  className?: string;
}

/**
 * An exact reference shown short: readers see a few characters, the tooltip and link carry
 * the whole value, and the copy button copies it exactly.
 */
export default function ReferenceDisplay({ kind, value, prefix = "", href, copy = true, className }: ReferenceDisplayProps) {
  const text = `${prefix}${shortReference(kind, value)}`;
  return (
    <span className={classNames("inline-flex items-center gap-1 align-middle", className)}>
      {href === undefined ? (
        <span className="font-mono" title={value}>{text}</span>
      ) : (
        <Link className="app-action-link font-mono" to={href} title={value}>{text}</Link>
      )}
      {copy === false ? null : <CopyReference value={value} label={typeof copy === "string" ? copy : undefined} />}
    </span>
  );
}
